import { DateTime } from "luxon";

export interface IData {
  _id: string;
  email: string;
  firstName: string;
  lastName: string;
  japaneseFirstName: string;
  japaneseLastName: string;
  mobileNumber: string;
  password: string;
  confirmPassword: string;
  streetAddress: string;
  postCode: string;
  prefectures: string;
  companyName: string;
  status: ENUM_USER_STATUS;
  importantStatus: DataImportantStatusEnum;
  createdAt: string;
  updatedAt: string;
}
export enum ENUM_USER_STATUS {
  ACTIVE = "1",
  INACTIVE = "2",
  DELETED = "3",
}
export enum ENUM_USER_SHIPPING_STATUS {
    YES = 1,
    NO = 2,

}

export interface IUserOrderData {
  _id: string;
  orderId: string;
  createdAt: string;
  totalPrice: number;
  invoiceId: string;
}

export enum DataImportantStatusEnum {
  Null = "Null",
  IMPORTANT = "IMPORTANT",
  NOT_IMPORTANT = "NOT_IMPORTANT",
}
export interface UserState {
  formData: IData;
  list: IData[];
  loading: boolean;
  buttonLoading: boolean;
  search: string;
  pageNo: number;
  pageSize: number;
  totalRow: number;
  orderBy: string;
  orderDir: string;
  toggleLoading: boolean;
  orders: IUserOrderData[];
  orderPageNo: number;
  orderPageSize: number;
  orderTotalRow: number;
  endDate: DateTime | null;
  startDate: DateTime | null;
}

export type InitialState = UserState;
